import { render, staticRenderFns } from "./WarehouseDataWidget.vue?vue&type=template&id=26b2ef58&"
import script from "./WarehouseDataWidget.vue?vue&type=script&lang=js&"
export * from "./WarehouseDataWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports